// ──────────────────────────────────────────────────────────────
// 신청 상태 정의·헬퍼 — 단일 진실 공급원
// 미신청 → 작성중 → 신청완료 → 수혜중. (2026-06-18 모듈화 8단계)
// ──────────────────────────────────────────────────────────────
const STS = [
  { v: 'none', l: '미신청', i: '', bg: '#FBF6EE', co: '#9CA3AF' },
  { v: 'drafting', l: '작성중', i: '', bg: '#FFE4CC', co: '#FF7A00' },
  { v: 'applied', l: '신청완료', i: '', bg: '#D1FAE5', co: '#10B981' },
  { v: 'receiving', l: '수혜중', i: '', bg: '#10B981', co: '#FFFFFF' },
];

// 상태값 → 상태 객체 (없으면 첫 항목 '미신청')
const gSI = (s) => STS.find((x) => x.v === s) || STS[0];
// 상태값 → 진행 단계 인덱스 (없으면 0)
const gSX = (s) => { const i = STS.findIndex((x) => x.v === s); return i < 0 ? 0 : i; };

module.exports = { STS, gSI, gSX };
